import type { RendererElement, RendererNode, VNode } from 'vue';

type Slot = VNode<
  RendererNode,
  RendererElement,
  {
    [key: string]: any;
  }
>;

export const getVisibleElements = (slots: Slot[]): Slot[] => {
  const results: Slot[] = [];
  slots?.forEach((slot) => {
    // @ts-expect-error type is missing some properties
    if (slot.type?.name === 'TDropdownItem') {
      results.push(slot);
    } else if (Array.isArray(slot.children)) {
      results.push(...getVisibleElements(slot.children as Slot[]));
    }
  });

  return results;
};
